import { SvgProps } from "@/utils/types";

export const TentAlt = ({
  primaryColor = "#C9BFFB",
  secondaryColor = "#D4DF65",
  tertiaryColor = "#06B992",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => (
  <svg
    width="29"
    height="35"
    className={className}
    viewBox="0 0 29 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.3331 10.7337H1.66699V14.0086H27.3331V10.7337Z"
      fill={primaryColor}
    />
    <path
      d="M14.4373 2.24072C10.9899 5.14303 6.695 7.58191 3.8252 9.06236H25.0067C22.0838 7.6089 17.8106 5.21873 14.4373 2.24072Z"
      fill={primaryColor}
    />
    <path
      d="M25.9782 26.0845H2.74805V33.128H25.9782V26.0845Z"
      fill={tertiaryColor}
    />
    <path
      d="M5.68481 15.7346H2.74805V24.4132H5.68481V15.7346Z"
      fill={secondaryColor}
    />
    <path
      d="M25.9778 15.7346H23.041V24.4132H25.9778V15.7346Z"
      fill={secondaryColor}
    />
    <path
      d="M29 15.6806V9.06236C28.9928 9.05973 28.9278 9.03274 28.8123 8.98337V14.8986H0.639339V8.76746C0.24287 8.95375 0.0137845 9.05644 0 9.06236V15.6806H1.0811V24.5178H1.94821V15.1744H6.51811V24.5178H22.7681V15.1744H27.338V24.5178H27.6458V15.6806H29ZM21.3752 24.4132H7.35174V15.7346H21.3752V24.4132Z"
      fill={outlineColor}
    />
    <path
      d="M28.8123 14.8986V8.98339C27.5283 8.43702 19.9278 5.09039 15.0179 0.514766L14.4659 0L13.9 0.498967C9.34852 4.51374 2.70701 7.79455 0.638672 8.76747V14.8986H28.8123ZM14.4363 2.24074C17.8096 5.21875 22.0828 7.60892 25.0058 9.06238H3.82421C6.69401 7.58193 10.9882 5.14305 14.4363 2.24074ZM27.3327 10.7337V14.0086H1.6666V10.7337H27.3327Z"
      fill={outlineColor}
    />
    <path
      d="M27.3379 25.0635H22.768V24.5178H6.51806V25.0635H1.94817V24.5178H1.08105V34.8H27.6458V24.5178H27.3379V25.0635ZM25.9785 33.128H2.74832V26.0845H25.9785V33.128Z"
      fill={outlineColor}
    />
    <path
      d="M6.51814 15.1744H1.94824V24.5178H6.51814V15.1744ZM2.7484 24.4132V15.7346H5.68516V24.4132H2.7484Z"
      fill={outlineColor}
    />
    <path
      d="M6.51814 24.5178H1.94824V25.0635H6.51814V24.5178Z"
      fill={outlineColor}
    />
    <path
      d="M27.3375 15.1744H22.7676V24.5178H27.3375V15.1744ZM23.0413 24.4132V15.7346H25.9781V24.4132H23.0413Z"
      fill={outlineColor}
    />
    <path
      d="M27.3375 24.5178H22.7676V25.0635H27.3375V24.5178Z"
      fill={outlineColor}
    />
  </svg>
);
